import type { IconData } from '@stacksjs/iconify-core'

export const natureTree: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m8 0l8 8h-5l5 5h-5v3H5v-3H0l5-5H0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default natureTree
